export default "__VITE_ASSET__CMmUOEXo__"